// extracted by mini-css-extract-plugin
export default {"tabContainer":"tabContainer-xrfCQ","inputDescription":"inputDescription-MMbVs","hr":"hr-swYDL","durationContainer":"durationContainer-Av_aJ","durationIcon":"durationIcon-jS0nH"};